module.exports = __webpack_public_path__ + "static/img/rank_291.981b731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_291.png
// module id = DIs8
// module chunks = 0